<div class="form-group flags">
    <mat-select [(ngModel)]="locale" class="flag flag-{{locale}}" (ngModelChange)="switchLocale()">
        <mat-option *ngFor="let locale of locales$ | async" [value]="locale.id">
            <span class="flag flag-{{ locale.id }}"></span>
            <span class="text">{{ locale.id | uppercase }}</span>
        </mat-option>
    </mat-select>
</div>
